export const handleDownload = async (fileUrl) => {
  const filesName = fileUrl?.split("/");
  const fileName = filesName[filesName?.length - 1];
  const response = await fetch(fileUrl);
  const blob = await response.blob();

  const url = window.URL.createObjectURL(new Blob([blob]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", fileName); // Replace with desired filename
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};


export function filterUniqueLevels(data) {
  const uniqueLevels = [];
  const seenLevels = new Set();

  data.forEach(item => {
    if (!seenLevels.has(item.level)) {
      uniqueLevels.push(item);
      seenLevels.add(item.level);
    }
  });

  return uniqueLevels;
}


export function transformArrayToPremier(inputArray) {
  console.log("inputArray" , inputArray);
  const newArray = [];

  inputArray.forEach(item => {
    console.log("Item " , item.label , item.label === "Premier");
      if (item.label === "Premier") {
          // Add two new objects if the element is "Premier"
          newArray.push({
              ...item,
              label: "Premier Full Trial"
          });
          newArray.push({
              ...item,
              label: "Premier Short Trial"
          });
      } else {
          // Otherwise, add the item unchanged
          newArray.push(item);
      }
  });

  return newArray;
}